import { IHttpErrorPayload, IHttpSuccessPayload } from '@core/models';

export class Result {
  status: string = '';
  message: string = '';
  errCode?: string;
  dateTime?: Date = new Date();
  retryRequired?: boolean;
  isFailed?: boolean;
  resultNav?: ResultNav[];
}

export interface ResultNav {
  label: string;
  path: string;
  displayType: 'Primary' | 'Secondary' | 'Teritory';
}

export interface IResultPageState {
  title: string;
  alertType: 'Success' | 'Warning' | 'Failed';
  navigationDtls: IResultNavigationDetails[];
  resultPayload: Partial<IHttpSuccessPayload<any> | IHttpErrorPayload>;
  serviceCode?: string;
  subTitle1?: string;
  subTitle2?: string;
  subTitle3?: string;
}

export interface IResultNavigationDetails {
  path: Array<string>;
  state: any;
  btnLabel: string;
  btnClass?: 'btn-primary' | 'btn-secondary' | 'btn-link' | 'btn-tertiary';
  btnType: 'reset' | 'button' | 'submit';
}
